import { Avatar, Backdrop, Box, Button, Card, Checkbox, Divider, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LOGO from '../../assets/images/logo_v3.svg';
import { numberFormat } from "../../utils/nunberFormat";

import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { concatenateStrings } from "../../utils/concatenateStrings";
import { convertOrderStatusCodeToOrderStatusEnum, convertOrderStatusEnumToStatusCode } from "../../utils/convertOrderStatusValue";
import { convertDateStringToNormalString, convertDateStringToNormalTime } from "../../utils/convertDateFormat";
import { OrderStatusEnum } from "../../enums/orderStatus";
import { OrderModel } from "../../models/order";
import { calculateOrderProductUnitByCarts } from "../../utils/calculateOrderProductUnitByCarts";
import { CartsModel } from "../../models/carts";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { SECONDARY_COLOR } from "../../constants/colors";
import { viewGoogleMapLocation } from "../../utils/viewGoogleMapLocation";
import { IMAGE_RIDER_PROFILE } from "../../lib/endpoints/profileImage";
import PromotionText from "../../components/PromotionText";
import { PromotionEnumType } from "../../enums/promotionEnum";
import { IMAGE_ORDER_URL } from "../../constants/imageUrl";
import { useEffect, useState } from "react";
import { ORDER_ADMIN_FIND_ORDER_LOG } from "../../lib/endpoints/order";
import axios from "../../lib/axios";
import { findOrderCreateTime } from "../../utils/findOrderCreareTime";

interface Props {
    onClose: VoidFunction,
    selectedData: OrderModel,
}

const OrderDetail = ({ onClose, selectedData }: Props) => {
    const [dataOrderLog, setDataOrderLog] = useState<OrderModel[]>([])
    const handleGetOrderLog = async () => {
        try {
            const res = await axios.get(ORDER_ADMIN_FIND_ORDER_LOG + "/?orderId=" + selectedData?.id);
            setDataOrderLog(res?.data);
        } catch (err) {

        }
        finally {

        }

    }

    useEffect(() => {
        if (selectedData?.updateByAdmin) {
            handleGetOrderLog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedData])
    const { i18n, t } = useTranslation("global");
    // const controller = useOrderController();

    return <Box>
        <IconButton onClick={onClose} sx={{ mb: 1 }}>
            <KeyboardBackspaceIcon />
        </IconButton>
        <Typography variant="h5" color="#737373" fontWeight="bold" sx={{
            mb: 1,
            mt: 1
        }}>{t("order_page.Order detail")}</Typography>
        <Button onClick={() => viewGoogleMapLocation(selectedData?.merchant?.location.coordinates[1], selectedData?.merchant?.location.coordinates[0], parseFloat(selectedData?.address?.latitude), parseFloat(selectedData?.address?.longitude))} color="secondary" variant="contained" sx={{ color: 'white', textTransform: 'none', mb: 2, mt: 1 }}>{t("order_page.View Google Map Location")}</Button>
        <Card sx={{ boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12);', p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <img src={LOGO} alt="" style={{ width: 104, height: 32 }} />
                <Typography fontSize={32}>{t("order_page.Order number")} : {selectedData?.orderNumber}</Typography>
                <Typography fontSize={32} fontWeight="bold">{t("order_page.Order ID")} : {selectedData?.orderNo}</Typography>
            </Box>

            <Typography>{t("order_page.Status")} : <span style={{
                lineHeight: 3,
                backgroundColor: 'rgba(255, 86, 48, 0.48)',
                borderRadius: "6px",
                padding: "2px 8px",

            }}>{convertOrderStatusCodeToOrderStatusEnum(selectedData?.status?.code)}</span></Typography>
            <Typography>{t("order_page.Payment method")} : <span style={{
                lineHeight: 3,
                backgroundColor: '#FFF2D6',
                borderRadius: "6px",
                padding: "2px 8px",
                color: "#1B806A",
                display: selectedData?.paymentMethod ? "inline" : "none",

            }}>{selectedData?.paymentMethod}</span></Typography>
            <Typography>{t("order_page.Shipment method")} : <span style={{
                lineHeight: 3,
                backgroundColor: SECONDARY_COLOR,
                borderRadius: "6px",
                padding: "2px 8px",
                color: "white",
                display: selectedData?.orderMethod ? "inline" : "none"
            }}>{selectedData?.orderMethod}</span></Typography>
            <Typography>ໄລຍະທາງ: <span style={{ fontWeight: 'bold' }}>{selectedData?.distance} Km</span></Typography>
            <Typography>ຂໍ້ມູນແຜນທີ່: <span style={{ fontWeight: 'bold' }}>ຮ້ານຄ້າ: latitude: {selectedData?.merchant?.location.coordinates[1]} longitude: {selectedData?.merchant?.location.coordinates[0]} <span style={{ color: 'red' }}>ລູກຄ້າ</span>: latitude: {selectedData?.address?.latitude}, longitude: {selectedData?.address?.longitude}</span></Typography>
            {(selectedData?.status?.code === 7 || selectedData?.status?.code === 8) && (
                <Typography>
                    ເຫດຜົນການຍົກເລີກ:
                    <span style={{ fontWeight: 'bold', color: 'red' }}>
                        {selectedData.status.code === 7
                            ? selectedData.description
                            : selectedData.remarkFromRider}
                    </span>
                </Typography>
            )}
            <Divider />
            <Box mt={2}>
                <Typography fontWeight="bold">{t("order_page.Detail User Address")}</Typography>
                <Typography>{t("order_page.Province")} : {selectedData?.address?.province}</Typography>
                <Typography>{t("order_page.District")} : {selectedData?.address?.district}</Typography>
                <Typography>{t("order_page.Village")} : {selectedData?.address?.village}</Typography>
                <Typography>{t("order_page.Detail")} : {selectedData?.address?.detail}</Typography>
            </Box>
            <Divider />

            {
                selectedData?.image?.url
                &&
                <Box sx={{ mt: 2 }}>
                    <Typography fontWeight="bold" sx={{ mb: 1 }}>ຮູບການຈ່າຍເງິນ</Typography>
                    <img onClick={() => window.open(IMAGE_ORDER_URL + selectedData?.image?.url)} src={IMAGE_ORDER_URL + selectedData?.image?.url} alt="" style={{ width: 100, height: 100, cursor: 'pointer' }} />
                </Box>
            }
            <Box mt={5}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">{t("order_page.From")}</Typography>
                        <Box mt={2}>
                            <Typography>{i18n.language === EN_ACCEPT_LANGUAGE ? selectedData?.merchant?.nameEn : selectedData?.merchant?.nameLa}</Typography>
                            <Typography>{selectedData?.merchant?.village && selectedData?.merchant?.village} {selectedData?.merchant?.district && ', ' + selectedData?.merchant?.district} {selectedData?.merchant?.provice && ', ' + selectedData?.merchant?.provice}</Typography>
                            <Typography>Phone: {selectedData?.merchant?.phone}</Typography>
                        </Box>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">{t("order_page.Customer")}</Typography>
                        <Box mt={2}>
                            <Typography>{selectedData?.customer?.profile?.fullName}</Typography>
                            <Typography>{selectedData?.customer?.profile?.address}</Typography>
                            <Typography>Phone: {selectedData?.customer?.phone}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={5}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">{t("order_page.Order Date")}</Typography>
                        <Box mt={2}>
                            <Typography>{findOrderCreateTime(selectedData)}</Typography>
                        </Box>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">{t("order_page.Received Date")}</Typography>
                        {
                            selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)
                            &&
                            <Box mt={2}>
                                <Typography>{convertDateStringToNormalString(selectedData?.updatedAt)}</Typography>
                                <Typography>{convertDateStringToNormalTime(selectedData?.updatedAt)}</Typography>
                            </Box>
                        }
                    </Grid>
                </Grid>
            </Box>
            <Box mt={10}>
                <TableContainer >
                    <Table>
                        <TableBody>
                            <TableRow hover tabIndex={-1} role="checkbox">
                                <TableCell align="left" sx={{ color: '#637381' }}>#</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Description")}</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>Barcodes</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Qty")}</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Unit Price")}</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Discount")}</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>Promotion</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Total")}</TableCell>
                            </TableRow>
                            {
                                selectedData?.carts?.map((item: CartsModel, index: number) => {
                                    return <TableRow key={index} hover tabIndex={-1} role="checkbox">
                                        <TableCell align="left" >{numberFormat(index + 1)}</TableCell>
                                        <TableCell align="left" >{i18n.language === EN_ACCEPT_LANGUAGE ? item?.product?.price?.masterProduct?.productNameEn : item?.product?.price?.masterProduct?.productNameLa}</TableCell>
                                        <TableCell align="left" >{concatenateStrings(item?.product?.price?.masterProduct?.barcodes)}</TableCell>
                                        <TableCell align="left" >{numberFormat(item?.quantity)}</TableCell>
                                        <TableCell align="left" >{numberFormat(item?.productPrice)} {t("order_page.kip")}</TableCell>
                                        <TableCell align="left" >{numberFormat(item?.discount)} {t("order_page.kip")}</TableCell>
                                        <TableCell align="left" ><PromotionText promotionType={item?.product?.promotion?.promotionType as PromotionEnumType} /></TableCell>
                                        <TableCell align="left" >{numberFormat(item?.total)} {t("order_page.kip")}</TableCell>
                                    </TableRow>
                                })
                            }

                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            {
                dataOrderLog?.length > 0
                &&
                <Box mt={10}>
                    <Typography variant="h4" color="red" textAlign="center">ລາຍການທີ່ຍັງບໍ່ມີການແກ້ໄຂ</Typography>
                    <TableContainer >
                        <Table>
                            <TableBody>
                                <TableRow hover tabIndex={-1} role="checkbox">
                                    <TableCell align="left" sx={{ color: '#637381' }}>#</TableCell>
                                    <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Description")}</TableCell>
                                    <TableCell align="left" sx={{ color: '#637381' }}>Barcodes</TableCell>
                                    <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Qty")}</TableCell>
                                    <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Unit Price")}</TableCell>
                                    <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Discount")}</TableCell>
                                    <TableCell align="left" sx={{ color: '#637381' }}>Promotion</TableCell>
                                    <TableCell align="left" sx={{ color: '#637381' }}>{t("order_page.Total")}</TableCell>
                                </TableRow>
                                {
                                    dataOrderLog[0]?.carts?.map((item: CartsModel, index: number) => {
                                        return <TableRow key={index} hover tabIndex={-1} role="checkbox">
                                            <TableCell align="left" >{numberFormat(index + 1)}</TableCell>
                                            <TableCell align="left" >{i18n.language === EN_ACCEPT_LANGUAGE ? item?.product?.price?.masterProduct?.productNameEn : item?.product?.price?.masterProduct?.productNameLa}</TableCell>
                                            <TableCell align="left" >{concatenateStrings(item?.product?.price?.masterProduct?.barcodes)}</TableCell>
                                            <TableCell align="left" >{numberFormat(item?.quantity)}</TableCell>
                                            <TableCell align="left" >{numberFormat(item?.productPrice)} {t("order_page.kip")}</TableCell>
                                            <TableCell align="left" >{numberFormat(item?.discount)} {t("order_page.kip")}</TableCell>
                                            <TableCell align="left" ><PromotionText promotionType={item?.product?.promotion?.promotionType as PromotionEnumType} /></TableCell>
                                            <TableCell align="left" >{numberFormat(item?.total)} {t("order_page.kip")}</TableCell>
                                        </TableRow>
                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            }
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'end', gap: 5 }}>
                <Box>
                    <Typography textAlign="end">{t("order_page.Total unit")}</Typography>
                    <Typography textAlign="end">{t("order_page.Subtotal")}</Typography>
                    <Typography textAlign="end">{t("order_page.Taxes")}</Typography>
                    <Typography textAlign="end">{t("order_page.Delivery fee")}</Typography>
                    <Typography textAlign="end">{t("order_page.Discount price")}</Typography>
                    <Typography textAlign="end">ສ່ວນຫຼຸດຈາກໂປຣໂມຊັນ</Typography>
                    <Typography textAlign="end">ສ່ວນຫຼຸດຈາກຄູປອງ</Typography>
                    <Typography textAlign="end" fontWeight="bold">{t("order_page.Total")}</Typography>
                </Box>
                <Box>
                    <Typography textAlign="end">{numberFormat(calculateOrderProductUnitByCarts(selectedData?.carts))} units</Typography>
                    <Typography textAlign="end">{numberFormat(selectedData?.totalNomalPriceNotIncludeVat)} kip</Typography>
                    <Typography textAlign="end">{numberFormat(selectedData?.totalVatPrice)} kip</Typography>
                    <Typography textAlign="end">{numberFormat(selectedData?.deliveryFee)} kip</Typography>
                    <Typography textAlign="end" color="red">- {numberFormat(selectedData?.totalDiscountPrice)} kip</Typography>
                    <Typography textAlign="end" color="red">- {numberFormat(selectedData?.totalDiscountPriceForPromotion)} kip</Typography>
                    <Typography textAlign="end" color="red">- {numberFormat(selectedData?.totalDiscountPriceForCoupon)} kip</Typography>
                    <Typography textAlign="end" fontWeight="bold">{numberFormat(selectedData?.totoalWithDeliveryFee)} kip</Typography>
                </Box>

            </Box>
            <Box sx={{ width: '100%', mt: 2, mb: 2 }}>
                <Box sx={{ backgroundColor: '#C8C8C8;', height: "1px" }} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: "center" }}>
                    <Box>
                        <Typography>{t("order_page.Driver Name")} :<span style={{ fontWeight: 'bold', fontSize: '20px', marginLeft: '10px' }}> {selectedData?.rider?.username}</span></Typography>
                        <Typography>{t("order_page.Driver contact")} :<span style={{ fontWeight: 'bold', fontSize: '20px', marginLeft: '10px' }}>{selectedData?.rider?.profile?.phoneNumber} </span> </Typography>
                    </Box>
                    <Avatar
                        alt="Rider"
                        sx={{
                            width: "80px",
                            height: '80px'
                        }}
                        src={IMAGE_RIDER_PROFILE + selectedData?.rider?.profile?.image?.url}
                    />

                </Box>
                <Box>
                    <Typography>{t("order_page.Contact admin for support")} : admin@gmail.com</Typography>
                    <Typography>020 554562236</Typography>
                </Box>
            </Box>
        </Card>
    </Box>
}
export default OrderDetail;